import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=052ca2d6&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=052ca2d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ca2d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('052ca2d6')) {
      api.createRecord('052ca2d6', component.options)
    } else {
      api.reload('052ca2d6', component.options)
    }
    module.hot.accept("./ConfirmDialog.vue?vue&type=template&id=052ca2d6&scoped=true", function () {
      api.rerender('052ca2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/ConfirmDialog.vue"
export default component.exports